/*
import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    GridItem12,
} from '../../../business-components/Grid/Grid'

//import {
//    RichTextEditorViewer
//} from '../../../business-components/RichTextEditor/RichTextEditorViewer'

import {
    RichTextEditorViewerPadrao
} from '../../../business-components/RichTextEditor/RichTextEditorViewerPadrao'

import {
    relatorioModoApresentacao,
} from './EstudoService'

import {
    CardGridEstudoPadrao,
} from './EstudoComp'



const EstudoFormObjetivos = ( { values, report } ) => {

    const ObjetivosPrincipaisPreocupacoes = ( props ) => {

        return (
            <GridItem12
                align='left'
                {...props}
            >
                {/*
                <RichTextEditorViewer
                    content={values.objetivosPrincipaisPreocupacoes}
                />
                *//*}
                <RichTextEditorViewerPadrao
                    content={values.objetivosPrincipaisPreocupacoes}
                />
            </GridItem12>
        )
    }

    return (
        <GridItem12>
            {report
                ?
                    <ObjetivosPrincipaisPreocupacoes
                        className='ml-5 mr-5 mt-2' // mudança da fonte: mt-5
                    />
                :
                    <CardGridEstudoPadrao
                        label={
                            !relatorioModoApresentacao(values)
                                ?
                                    LABEL.objetivosPrincipaisPreocupacoes
                                :
                                    HARDCODE.modoApresentacaoRelatorio
                        }
                        component={
                            <ObjetivosPrincipaisPreocupacoes
                                className='ml-2'
                            />
                        }
                        overflowX={false}
                    />
            }
        </GridItem12>
    )
}

export default EstudoFormObjetivos
*/
import React from 'react'

//import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    nvl,
} from '../../../business-components/Formata/Formata'

import {
    GridContainer,
    GridItem12,
 } from '../../../business-components/Grid/Grid'

 import {
    CardGridEstudo,
    CardGridDivHeaderDestaque1,
    CardGridDivH4Destaque,
    CardGridDivBody,
} from '../../../business-components/Card/Card'

//import {
//    RichTextEditorViewer
//} from '../../../business-components/RichTextEditor/RichTextEditorViewer'

import {
    RichTextEditorViewerPadrao
} from '../../../business-components/RichTextEditor/RichTextEditorViewerPadrao'

import {
    relatorioModoApresentacao,
} from './EstudoService'

import {
    GridContainerEstudoPadraoLg,
} from './EstudoComp'



const EstudoFormObjetivos = ( { values, report, indPagina } ) => {

    return (
        <GridItem12
            align='left'
        >
            {report || relatorioModoApresentacao(values)
                ?
                    //<div
                        //className={CLASSNAMEREPORT(values, report).formataReportMargemPaginaRelatorio} // mudança da fonte: mt-2
                    //>
                        /*
                        <RichTextEditorViewer
                            content={values.consideracaoFinal[indPagina]}
                        />
                        */
                        <RichTextEditorViewerPadrao
                            content={values.objetivosPrincipaisPreocupacoesPFCMLP[indPagina].richText}
                        />
                    //</GridItem12></div>
                :
                    <GridContainerEstudoPadraoLg
                        component={
                            <CardGridEstudo>
                                <CardGridDivHeaderDestaque1>
                                    <GridContainer>
                                        <GridItem12>
                                            <CardGridDivH4Destaque>
                                                {
                                                    nvl(values.objetivosPrincipaisPreocupacoesPFCMLP[indPagina].tituloPagina,
                                                        LABEL.objetivosPrincipaisPreocupacoesPFCMLP
                                                    )
                                                }
                                            </CardGridDivH4Destaque>
                                        </GridItem12>
                                    </GridContainer>
                                </CardGridDivHeaderDestaque1>

                                {//values.consideracaoFinal?.map((item, ind) => {

                                   // return item.richText && item.richText !== HARDCODE.richTextEditorVazio ? (
                                        <CardGridDivBody
                                            //key={ind}
                                        >
                                            <GridItem12
                                                className='ml-2'
                                            >
                                                {/*
                                                <RichTextEditorViewer
                                                    content={item}
                                                />
                                                */}
                                                <RichTextEditorViewerPadrao
                                                    //content={item.richText}
                                                    content={values.objetivosPrincipaisPreocupacoesPFCMLP[indPagina].richText}
                                                />
                                            </GridItem12>
                                        </CardGridDivBody>
                                    //)
                                    //:
                                    //(
                                    //    ''
                                    //)
                                //})
                                }
                            </CardGridEstudo>
                        }
                    />
            }
        </GridItem12>
    )
}

export default EstudoFormObjetivos